export default "__VITE_ASSET__Ql9Pmg3u__"